export default __webpack_public_path__ + "static/media/admin-cabang.dfd02b55.png";